/** Mirrors pricer PRICER_AGE_CASES / AbstractProvider.getPricerAge. */
export const AGE_RULES = {
  AGE_ON_EFFECTIVE_DATE: "ageOnEffectiveDate",
  AGE_BY_YEAR: "ageByYear",
  AGE_M_PLUS_1: "ageMPlus1",
  AGE_EFFET_PLUS_12: "ageEffetPlus12",
  AGE_BY_PREVIOUS_YEAR: "ageByPreviousYear",
  AGE_ON_JAN_FIRST: "ageOnJanFirst",
};

export const AGE_RULE_VALUES = Object.values(AGE_RULES);

const toUtcDay = (value) => {
  if (!(value instanceof Date) || Number.isNaN(value.getTime())) return null;
  return new Date(
    Date.UTC(value.getUTCFullYear(), value.getUTCMonth(), value.getUTCDate()),
  );
};

const startOfUtcYear = (date) =>
  new Date(Date.UTC(date.getUTCFullYear(), 0, 1));

const endOfUtcYear = (date) =>
  new Date(Date.UTC(date.getUTCFullYear(), 11, 31));

const startOfUtcMonth = (date) =>
  new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), 1));

/** Full completed years between earlier and later (moment.diff('years')). */
const diffFullYears = (later, earlier) => {
  let years = later.getUTCFullYear() - earlier.getUTCFullYear();
  const monthDelta = later.getUTCMonth() - earlier.getUTCMonth();
  if (
    monthDelta < 0 ||
    (monthDelta === 0 && later.getUTCDate() < earlier.getUTCDate())
  ) {
    years -= 1;
  }
  return years;
};

/**
 * @param {Date} birthDate
 * @param {Date} effectiveDate
 * @param {string} rule
 * @returns {number|null}
 */
export const computeAge = (
  birthDate,
  effectiveDate,
  rule = AGE_RULES.AGE_ON_EFFECTIVE_DATE,
) => {
  const birth = toUtcDay(birthDate);
  const effective = toUtcDay(effectiveDate);
  if (!birth || !effective) return null;

  switch (rule) {
    case AGE_RULES.AGE_ON_EFFECTIVE_DATE:
      return diffFullYears(effective, birth);

    case AGE_RULES.AGE_ON_JAN_FIRST:
      return diffFullYears(startOfUtcYear(effective), birth);

    case AGE_RULES.AGE_BY_PREVIOUS_YEAR: {
      const previousYearEnd = endOfUtcYear(
        new Date(Date.UTC(effective.getUTCFullYear() - 1, 0, 1)),
      );
      return diffFullYears(previousYearEnd, birth);
    }

    case AGE_RULES.AGE_M_PLUS_1: {
      const threshold = startOfUtcMonth(
        new Date(
          Date.UTC(effective.getUTCFullYear(), birth.getUTCMonth() + 1, 1),
        ),
      );
      const baseAge = diffFullYears(threshold, birth);
      return effective.getTime() < threshold.getTime() ? baseAge - 1 : baseAge;
    }

    case AGE_RULES.AGE_EFFET_PLUS_12: {
      const refDate = new Date(
        Date.UTC(
          effective.getUTCFullYear(),
          effective.getUTCMonth() + 12,
          effective.getUTCDate(),
        ),
      );
      return diffFullYears(refDate, birth);
    }

    case AGE_RULES.AGE_BY_YEAR:
    default:
      return (
        startOfUtcYear(effective).getUTCFullYear() -
        startOfUtcYear(birth).getUTCFullYear()
      );
  }
};
